import ActivityLog from "./component/ActivityLog";

const Activity = ({ data }) => {
  const logs = data?.audit_logs ?? [];
  return (
    <div className="h-full overflow-y-auto custom-scrollbar px-6 py-4">
      <ActivityLog logs={logs} />
    </div>
  );
};

export default Activity;